(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-service-item-access', {
                parent: 'entity',
                url: '/agent-service-item-access?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentServiceItemAccess.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-accesses.html',
                        controller: 'AgentServiceItemAccessController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentServiceItemAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-service-item-access-detail', {
                parent: 'entity',
                url: '/agent-service-item-access/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentServiceItemAccess.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-detail.html',
                        controller: 'AgentServiceItemAccessDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentServiceItemAccess');
                        $translatePartialLoader.addPart('agentCategoryAccessType');
                        $translatePartialLoader.addPart('agentCategoryViewMode');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentServiceItemAccess', function ($stateParams, AgentServiceItemAccess) {
                        return AgentServiceItemAccess.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-service-item-access.new', {
                parent: 'agent-service-item-access',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-dialog.html',
                        controller: 'AgentServiceItemAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    accessType: null,
                                    viewMode: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-service-item-access', null, {reload: true});
                    }, function () {
                        $state.go('agent-service-item-access');
                    });
                }]
            })
            .state('agent-service-item-access.edit', {
                parent: 'agent-service-item-access',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-dialog.html',
                        controller: 'AgentServiceItemAccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentServiceItemAccess', function (AgentServiceItemAccess) {
                                return AgentServiceItemAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-service-item-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-service-item-access.delete', {
                parent: 'agent-service-item-access',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-service-item-access/agent-service-item-access-delete-dialog.html',
                        controller: 'AgentServiceItemAccessDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentServiceItemAccess', function (AgentServiceItemAccess) {
                                return AgentServiceItemAccess.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-service-item-access', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
